import React, { PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { color, mapState } from '@deerplusofficial/pos-helper';
import { connect } from 'react-redux';
import actions from '../../actions';
import CartItemListToolBar from './CartItemListToolBar';
import CartToolBarToggle from './CartToolBarToggle';
import CartReadonlyToolBar from './CartReadonlyToolBar';

const Container = styled.div`
  border-bottom: 1px solid ${color.border};
`;

class CartToolBar extends PureComponent {
  static propTypes = {
    readonly: PropTypes.bool,
    preOrder: PropTypes.shape({
      isListOpen: PropTypes.bool,
      isDetailOpen: PropTypes.bool,
    }),
  };

  static defaultProps = {
    readonly: false,
    preOrder: {},
  };

  onPreOrderDetailClose = () => {
    const {
      resetPreOrder,
      resetCartItem,
      resetOrder,
      preOrder: { id: preOrderId },
    } = this.props;

    if (preOrderId) {
      resetPreOrder();
      resetOrder();
      resetCartItem();
      return;
    }

    resetPreOrder();
  };

  renderToolBar = () => {
    const { readonly, preOrder, togglePreOrderList } = this.props;

    if (readonly) return <CartReadonlyToolBar />;
    else if (preOrder.isListOpen)
      return (
        <CartToolBarToggle
          toggle={togglePreOrderList}
          title="稍後結帳訂單列表"
        />
      );
    else if (preOrder.isDetailOpen)
      return (
        <CartToolBarToggle
          toggle={this.onPreOrderDetailClose}
          title="稍後結帳訂單資訊"
        />
      );
    else return <CartItemListToolBar />;
  };

  render() {
    return <Container>{this.renderToolBar()}</Container>;
  }
}

const {
  list: { toggle: togglePreOrderList },
  detail: { reset: resetPreOrder },
} = actions.preOrder;
const { reset: resetCartItem } = actions.cart;
const { reset: resetOrder } = actions.order;

export default connect(
  mapState(['preOrder']),
  {
    togglePreOrderList,
    resetPreOrder,
    resetCartItem,
    resetOrder,
  }
)(CartToolBar);



// WEBPACK FOOTER //
// ./src/components/Cart/CartToolBar.js